import { AxiosRequestConfig } from "axios";
import VaivemAuthService from "@/services/vai-vem.auth.service";

export const vaivemHandleRequest = (config: AxiosRequestConfig) => {
  const token = VaivemAuthService.token;
  const authHeader = token ? `Bearer ${token}` : "";
  config.headers = {
    ...config.headers,
    Authorization: authHeader,
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  return config;
};

export const VaiVemHandleErrorRequest = (error: any) =>
  Promise.reject(error);